/**
 * @prettier
 * @flow
 */
import { isString } from 'src/utils/string/isString';

export function upperCase<T: ?string>(value: T): T {
    if (!isString(value)) {
        return value;
    }
    return value.toUpperCase();
}
